import { render, staticRenderFns } from "./standby.vue?vue&type=template&id=2c8f9170&scoped=true&lang=pug"
import script from "./standby.vue?vue&type=script&lang=js"
export * from "./standby.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8f9170",
  null
  
)

export default component.exports